const SCHEDULING_ROUTES_NAMES_MAPPING = {
  piloting: "scheduling-piloting",
  planning: "scheduling-planning",
};

export {SCHEDULING_ROUTES_NAMES_MAPPING};
